import { Link } from 'react-router-dom'

export function Logo({ compact = false, light = false, className = '' }: { compact?: boolean; light?: boolean; className?: string }) {
  return (
    <Link className={`brand-logo ${compact ? 'brand-logo--compact' : ''} ${light ? 'brand-logo--light' : ''} ${className}`} to="/" aria-label="AthLink — accueil">
      <img src={compact ? '/brand/athlink-monogram.png' : '/brand/athlink-logo-complete.png'} alt="AthLink" />
    </Link>
  )
}
